import { render, staticRenderFns } from "./PalletModal.vue?vue&type=template&id=55317487&scoped=true&"
import script from "./PalletModal.vue?vue&type=script&lang=js&"
export * from "./PalletModal.vue?vue&type=script&lang=js&"
import style0 from "./PalletModal.vue?vue&type=style&index=0&id=55317487&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55317487",
  null
  
)

export default component.exports